import axios from 'axios';

export default axios.create({
    baseURL: "https://www.vdlsoft.nl/api/v1/",
    withCredentials: true
});